import BaseInstitutionEntity from "@/models/Shared/BaseInstitutionEntity";

export default class PublicHoliday extends BaseInstitutionEntity {
    name: string = '';
    createdAtUtc: Date;
    holidayDate: Date;
    regionId: string;
    updatedAtUtc: Date;
}